/**
 * Bridge so App-level mutations can record undo actions from the open SprintDetail view.
 */

import { drainInboxUndoActions } from './inboxUndoHistory';

let recordActionFn = null;

export function setRecordAction(handler) {
  recordActionFn = handler;
  if (!handler) return;
  for (const action of drainInboxUndoActions()) {
    handler(action);
  }
}

export function hasUndoRecorder() {
  return typeof recordActionFn === 'function';
}

export function recordUndoableAction(action) {
  if (!recordActionFn) return false;
  recordActionFn(action);
  return true;
}
